import {DateTime} from "luxon";
import { COMINGSOON_PERIOD_IN_MINUTES } from "./constants";

const getDateTime = (date: DateTime | string): DateTime => {
    return typeof date == 'string' ? DateTime.fromISO(date) : date;
}

/**
 * Checks if the time is eligible to show webinar
 * 0 minutes before and + 5 minutes after
 * @param begin
 * @param end
 */
const isWebinarNow = (begin: DateTime | string , end: DateTime | string) => {
    if (typeof begin == 'string') {
        begin = DateTime.fromISO(begin);
    }
    if (typeof end == 'string') {
        end = DateTime.fromISO(end);
    }
    const now = DateTime.local();
    return now >= (begin as DateTime) && now <= (end.plus({ minutes: COMINGSOON_PERIOD_IN_MINUTES}) as DateTime)
}

const isLiveByTime = (begin: DateTime | string, end: DateTime | string) => {
    if (typeof begin == 'string') {
        begin = DateTime.fromISO(begin);
    }
    if (typeof end == 'string') {
        end = DateTime.fromISO(end);
    }
    const now = DateTime.local();
    return now >= (begin as DateTime) && now <= (end as DateTime)
}

const haveTimeJoint = (end: DateTime | string, begin: DateTime | string) => {

    begin = getDateTime(begin);
    end = getDateTime(end);

    return begin.toISO() === end.toISO();
}

const isComingSoon = (begin: DateTime | string) => {
    if (typeof begin == 'string') {
        begin = DateTime.fromISO(begin);
    }
    const now = DateTime.local();
    return now < (begin as DateTime);
}

export const isFinished = (end: DateTime | string) => {
    if (typeof end == 'string') {
        end = DateTime.fromISO(end);
    }
    const now = DateTime.local();
    return now > end;
}

const secondsBeforeMoment = (begin: DateTime | string): number => {
    if (typeof begin == 'string') {
        begin = DateTime.fromISO(begin);
    }
    const now = DateTime.local();
    return begin.minus(+now).toSeconds();
}

export { isWebinarNow, isComingSoon, secondsBeforeMoment, isLiveByTime, haveTimeJoint }